module.exports = __webpack_public_path__ + "static/img/sate_right.beceb543.png";